import { createTRPCProxyClient, httpLink } from "@trpc/client";
import type { API } from "../backend/routes/trpc";

export const api = createTRPCProxyClient<API>({
  links: [httpLink({ url: "/api/trpc" })],
});
